export default __webpack_public_path__ + "static/realWorldImage4-117f3214526b153597e55d413cbca0fe.webp";